import React, { FC, useState, useEffect, ReactNode } from 'react'
import i18n from 'i18next'
import { IonHeader, IonModal, IonFooter } from '@ionic/react'
import { MktButton } from '@cps'
import { toDecimal } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  visible: boolean;
  header?: ReactNode;
  max?: number;
  min?: number;
  onSave?: (amount: number) => void;
  onClose?: () => void;
}

const AmountKeyboard: FC<IProps> = ({ visible, header, max, min, onSave, onClose }) => {
  const [text, setText] = useState<string>('')
  const [status, setStatus] = useState<number>(0)

  const inputDigit = (digit: number) => {
    if (window.bo === 'cn') {
      const splitArr: any[] = text.split('.')
      if (!splitArr[1] || (splitArr[1] && splitArr[1].length < 2)) {
        setText(text + String(digit))
      }
    } else {
      let newStr = String(toDecimal((parseFloat(text) || 0) * 100))
      newStr += digit
      setText(toDecimal(parseFloat(newStr || '0') / 100, 2, true))
    }
  }

  const inputPoint = () => {
    if (text.indexOf('.') !== -1) return
    setText(text + '.')
  }

  const backspace = () => {
    if (text.length > 0) {
      if (window.bo === 'cn') {
        setText(text.substr(0, text.length - 1))
      } else {
        let newStr = String(toDecimal((parseFloat(text) || 0) * 100))
        newStr = newStr.substr(0, newStr.length - 1)
        setText(toDecimal(parseFloat(newStr || '0') / 100, 2, true))
      }
    }
  }

  const submit = () => {
    const value = parseFloat(text)
    onSave && onSave(value)
  }

  const currency = bo === 'us' ? '$' : bo === 'cn' ? '¥' : '€'

  useEffect(() => {
    if (text) {
      if (min && max) {
        const value: number = parseFloat(text)
        if (value > max) {
          setStatus(2)
        } else if (value < min) {
          setStatus(0)
        } else {
          setStatus(1)
        }
      } else {
        setStatus(1)
      }
    } else {
      setStatus(0)
    }
  }, [text])

  useEffect(() => {
    setText('')
  }, [visible])

  return (
    <IonModal isOpen={visible} cssClass='mkt-amount-keyboard'>
      <IonHeader className='modal-header'>
        <span className='title'>{i18n.t('mkt.giftCard.customAmount')}</span>
        <div data-cypid='mmgCloseCustomAmount' className='right' onClick={onClose}>
          <i className='iconfont icon-close'></i>
        </div>
      </IonHeader>
      <div className='modal-content'>
        <div className='amount-area'>
          <div className='amount'>
            {text ? <span className={`${status === 2 ? 'exceed' : ''}`}>{text}</span> : <div className='fix-line'></div>}
          </div>
          {min || max ? <div className='range'><span>{i18n.t('mkt.giftCard.inputRange')}{currency}{min || '0'}-{currency}{max || 0}</span></div> : ''}
        </div>
        <ul data-cypid='mmgNumInput' className='numpad'>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(x => (
            <li key={x} onClick={() => inputDigit(x)}>{x}</li>
          ))}
          {window.bo === 'cn' && <li onClick={() => inputPoint()}>.</li>}
          {window.bo === 'us' && <li></li>}
          <li onClick={() => inputDigit(0)}>0</li>
          <li onClick={() => backspace()}>
            <i className='iconfont icon-backspace' />
          </li>
        </ul>
      </div>
      <IonFooter className='button-bar'>
        <MktButton text='OK' disabled={status !== 1} onClick={submit}></MktButton>
      </IonFooter>
    </IonModal>
  )
}

export default AmountKeyboard
